module.exports = __webpack_public_path__ + "img/know your polymer.27cc5e32.jpg";